<template>
  <section class="flex flex-col gap-lg">
    <div
      v-for="(deliveryMode, deliveryModeIndex) in deliveryModes"
      :class="{
        'marketplace-checkout--delivery-modes-non-consolidate-wrapper no-overflow': !isConsolidated
      }"
    >
      <div v-if="!isConsolidated" class="p-md bg-gray-100">
        <p class="text-base fw-strong c-blue-400 m-0">
          {{ 'Estimated Ship Date' | t }}:
          {{ deliveryModes[deliveryModeIndex].estimatedShipDate }}
        </p>
      </div>
      <ul v-if="!isConsolidated" class="marketplace-checkout--non-consolidate-products">
        <li
          v-for="deliveryModeEntryNumber in deliveryMode.entryNumber.split(',')"
          :key="`delivery-mode-entry-number-${deliveryModeEntryNumber}`"
        >
          <span class="text-base fw-strong">
            {{ getProductByEntryNumber(deliveryModeEntryNumber)?.number }}
          </span>
          <span>{{ getProductByEntryNumber(deliveryModeEntryNumber)?.title }}</span>
          <span class="text-sm">
            {{ 'Code' | t }}: {{ getProductByEntryNumber(deliveryModeEntryNumber)?.code }}
          </span>
        </li>
      </ul>
      <ul
        :class="{
          'marketplace-checkout--delivery-modes': true,
          'delivery-modes-non-consolidate': !isConsolidated
        }"
      >
        <li
          v-for="(mode, modeIndex) in deliveryModes[deliveryModeIndex].modes"
          :key="`delivery-mode-${deliveryModeIndex}-${modeIndex}-${mode.code}`"
        >
          <input
            type="radio"
            :id="`delivery-mode-${deliveryModeIndex}-${modeIndex}-${mode.code}`"
            :name="`delivery-mode-${deliveryModeIndex}-${modeIndex}-${mode.code}`"
            :value="mode"
            v-model="selections[deliveryModes[deliveryModeIndex].entryNumber]"
            @change="$emit('updateDeliveryModes', selections)"
          />
          <label
            :for="`delivery-mode-${deliveryModeIndex}-${modeIndex}-${mode.code}`"
            :class="{
              'flex-1 flex items-start justify-between': true,
              'gap-lg': isConsolidated,
              'flex-col gap-xs': !isConsolidated
            }"
          >
            <span class="flex flex-col items-start justify-start gap-xs m-0">
              <span class="text-base fw-strong">{{ mode.name }}</span>
              <span class="c-green-400">
                {{ 'Estimated Delivery' | t }}: {{ mode.estimatedDeliveryDate }}
              </span>
            </span>
            <span class="m-0">
              {{ mode.deliveryCost.formattedValue === '$0.00' ? 'FREE' : mode.deliveryCost.formattedValue }}
            </span>
          </label>
        </li>
      </ul>
    </div>
  </section>
</template>

<script>
import {mapGetters} from 'vuex';
import t from '../../main/i18n';

export default {
  name: 'DeliveryModesSelector',
  filters: {
    t
  },
  props: {
    isConsolidated: {type: Boolean, required: true},
    deliveryModes: {type: Array, required: true},
    selectedDeliveryModes: {type: Object, required: true}
  },
  data() {
    return {
      selections: []
    };
  },
  computed: mapGetters('marketplace', ['cartEntries']),
  created() {
    this.selections = this.deliveryModes.reduce((acc, deliveryMode) => {
      acc[deliveryMode.entryNumber] = deliveryMode.modes.find(_deliveryMode => {
        return _deliveryMode.code === this.selectedDeliveryModes[deliveryMode.entryNumber]?.code;
      });
      return acc;
    }, {});

    this.$emit('updateDeliveryModes', this.selections);
  },
  methods: {
    getProductByEntryNumber(entryNumber) {
      const foundEntryNumber = parseInt(entryNumber.split(',')[0]);

      return this.cartEntries
        .find(cartEntry => cartEntry?.entryNumber === foundEntryNumber)?.product;
    }
  }
};
</script>

<style scoped lang="scss">
@import '../../../scss/variables';
@import '../../../scss/system';

.marketplace-checkout {
  &--delivery-modes-non-consolidate-wrapper {
    border: 1px solid $color-gray-400;
    border-radius: 0.8rem;
  }

  &--delivery-modes {
    list-style: none;
    padding: 0;
    margin: 0;
    border: 1px solid $color-gray-400;
    border-radius: 0.8rem;

    &.delivery-modes-non-consolidate {
      display: grid;
      grid-template-columns: repeat(auto-fit, minmax(210px, 1fr));
      border-left: none;
      border-right: none;
      border-bottom: none;
      border-radius: 0;

      li {
        flex-wrap: nowrap;

        &:not(:first-child) {
          border: none;
        }
      }
    }

    li {
      position: relative;
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      column-gap: 2.4rem;
      row-gap: 1.6rem;
      padding: 1.6rem;

      &:not(:first-child) {
        border-top: 1px solid $color-gray-400;
      }

      input[type="radio"] {
        min-width: 1.4rem;
        min-height: 1.4rem;
        accent-color: $color-blue-400;

        &:after {
          content: '';
          position: absolute;
          inset: 0;
          width: 100%;
          height: 100%;
          cursor: pointer;
        }
      }
    }

    label {
      color: initial;
      font-size: initial;
      font-weight: initial;
      margin-bottom: 0;
    }
  }

  &--non-consolidate-products {
    display: flex;
    flex-direction: column;
    gap: 1.6rem;
    list-style: none;
    padding: 1.6rem;
    margin: 0;
    border-top: 1px solid $color-gray-400;

    li {
      display: flex;
      flex-direction: column;
      align-items: start;
      justify-content: start;
      gap: 0.4rem;
    }
  }
}
</style>
